module.exports = __webpack_public_path__ + "media/images/mypage/icon/green-pale/ico_search-f7ff5e0acdd975fd81a24592a4c8eaf3.svg";